import { BrowserSupport } from '@tableau/browser-support';
import * as React from 'react';
import { ServerSettingsUnauthenticated } from '../../../settings/services/ServerSettingsUnauthenticated';

export interface SignInNoteDescriptionProps{
  signInNoteContainerStyleOverride?: React.CSSProperties;
}

const signInNoteContainerStyle: React.CSSProperties = {
  width: '375px',
  minHeight: '50px',
  marginTop: '50px',
  marginBottom: '0px',
  marginLeft: 'auto',
  marginRight: 'auto',
  wordWrap: 'break-word'
};

export function SignInNoteDescription(props: SignInNoteDescriptionProps): JSX.Element {
  let signInNoteText = ServerSettingsUnauthenticated.getSignInNoteText();
  let signInNoteUrl = ServerSettingsUnauthenticated.getSignInNoteUrl();
  if (!BrowserSupport.IsTouch() && ServerSettingsUnauthenticated.isSignInNoteEnabled() && !!signInNoteText){
    return(<div className="tb-sign-in-note-container" style={{...signInNoteContainerStyle, ...props.signInNoteContainerStyleOverride}}>
            {!!signInNoteUrl &&
              <a className="tb-sign-in-note-with-url" href={signInNoteUrl} target="_blank" rel="noopener noreferrer">{signInNoteText}</a>}
            {!signInNoteUrl &&
              <span className="tb-sign-in-note-without-url">{signInNoteText}</span>}
          </div>);
  } else {
    return (null);
  }
}
